import { useState, useEffect, useRef } from "react";

export interface DropdownOption {
  label: string;
  value: string;
}

export function useDropdown(initialValue: string, options: DropdownOption[]) {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(initialValue);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen(prev => !prev);
  const selectOption = (value: string) => {
    setSelected(value);
    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return {
    isOpen,
    selected,
    setSelected,
    toggleDropdown,
    selectOption,
    dropdownRef,
    options,
  };
}
